import { cx } from '../lib/cx';

interface StepperProps {
  steps: string[];
  /** Zero-indexed. */
  current: number;
  label?: string;
}

export default function Stepper({ steps, current, label = 'Progress' }: StepperProps) {
  const clamped = Math.min(Math.max(current, 0), steps.length - 1);

  return (
    <nav aria-label={label}>
      {/* Phone: the count and the current step, nothing else. */}
      <p className="t-meta text-grey-600 sm:hidden">
        Step <span className="t-numeral">{clamped + 1}</span> of{' '}
        <span className="t-numeral">{steps.length}</span>
        {' — '}
        <span className="font-semibold text-ink">{steps[clamped]}</span>
      </p>

      <ol className="mt-2 flex gap-1 sm:mt-0">
        {steps.map((step, i) => {
          const done = i < clamped;
          const active = i === clamped;
          return (
            <li key={step} className="flex-1" aria-current={active ? 'step' : undefined}>
              <span
                className={cx(
                  'block h-[3px] rounded-full',
                  done && 'bg-green-300',
                  active && 'bg-green-600',
                  !done && !active && 'bg-grey-200',
                )}
              />
              <span
                className={cx(
                  't-meta mt-2 hidden sm:block',
                  active ? 'font-semibold text-ink' : 'text-grey-600',
                )}
              >
                {step}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
